import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  submit_form() {
    this.formTarget.requestSubmit()
  }
//   TODO Add a text input watcher like the one in filterrific.
//   TODO Add clear input if possible.
}